export interface TellentPosition {
  guid: string;
  members: TellentPositionMember[];
  membersCount: number;
  name: string;
  descriptionHtml?: string | null;
  descriptionJson?: unknown | null;
}

export interface TellentPositionMember {
  assignedAt: string;
  avatarThumbUrl: string | null;
  email: string;
  firstName: string;
  guid: string;
  hasWorkEmail: boolean;
  lastName: string;
  login: string | null;
}

export interface TellentPositionResponse {
  data: TellentPosition;
}

export interface PositionDetailsDialogData {
  positionGuid: string;
}

export interface UpdatePositionPayload {
  name?: string;
  descriptionJson?: unknown | null;
}

export interface GeneratePositionDescriptionPayload {
  positionName: string;
}

export interface GeneratePositionDescriptionResponse {
  descriptionHtml: string;
}

export interface DeletePositionDialogData {
  position: TellentPosition;
}

export interface DeletePositionDialogResult {
  success: boolean;
}

export interface RenamePositionDialogData {
  positionGuid: string;
  positionName: string;
}

export interface RenamePositionDialogResult {
  success: boolean;
}

export interface PositionMemberConflict {
  member: TellentPositionMember;
  currentPosition: TellentPosition;
}

export interface ReassignMemberWarningDialogData {
  targetPositionName: string;
  members: PositionMemberConflict[];
}

export interface ReassignMemberWarningDialogResult {
  confirmed: boolean;
}

export interface ConfirmPositionChangeMember {
  guid: string;
  fullName: string;
  avatarThumbUrl: string | null;
  currentPosition: TellentPosition | null;
}

export interface ConfirmPositionChangeDialogData {
  targetPositionName: string;
  members: ConfirmPositionChangeMember[];
}

export interface ConfirmPositionChangeDialogResult {
  confirmed: boolean;
  addToHistory: boolean;
  effectiveDate: string;
}

export interface AssignMembersOptions {
  effectiveDate: string;
  addToHistory: boolean;
}

export interface UnassignMemberFromPositionDialogResult {
  success: boolean;
}

export enum PositionDetailsTab {
  Employees = 'employees',
  Description = 'description',
  Skills = 'skills',
}

export enum AddSkillsDropdownAction {
  CreateNewSkill = 'create-new-skill',
  ManageSkillMappings = 'manage-skill-mappings',
  ImportFromFile = 'import-from-file',
  GenerateSuggested = 'generate-suggested',
}
